module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BBREVIATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("ADF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Allied Democratic Forces. An insurgency movement against the Ugandan government that is currently based in North Kivu Province of the DRC.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("AFDL")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("French initialism for the Alliance of Democratic Forces for the Liberation of Congo-Zaire, a rebellion against Mobutu Sese Seko’s government that was headed by Laurent Kabila and orchestrated and supported by Uganda and Rwanda. It was instrumental in inciting the First Congo War.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("CAR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Central African Republic.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("CNDP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("French initialism for the National Congress for the Defense of the People. Insurgency that began in 2006 against the DRC government; a forerunner of M23.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("CWB")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Clowns Without Borders.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("DRC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Democratic Republic of the Congo (formerly Zaire, the Belgian Congo, and the Congo Free State).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("FAR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Forces Armeés Rwandaises (the Rwandan armed forces before 1994).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("FARDC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("French initialism for the Armed Forces for the Democratic Republic of the Congo, the government army of the DRC.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("FDLR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("French initialism for the Democratic Forces for the Liberation of Rwanda, a rebel group against the Rwandan government that is primarily active in the eastern DRC.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("ICC")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("International Criminal Court, based in The Hague.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("IDP")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Internally displaced people.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("LRA")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Lord’s Resistance Army. An insurgency movement against Yoweri Museveni’s government that emerged in the late 1980s. Previously based in northern Uganda and the former southern Sudan; remnants of the LRA are now believed to operate in the northeastern DRC, the southwestern CAR, and South Sudan.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("M23")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("An insurgency formed in 2012 against the DRC government and based in the eastern DRC. Named after March 23, 2009, when the CNDP (a forerunner of M23) signed a peace agreement with the DRC government. M23 surrendered in late 2013.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("MDD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Music, dance, and drama. Commonly used in Uganda to refer to the performing arts.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("NGO")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Nongovernmental organization. A broad term that includes both local, grassroots organizations and powerful international ones, all of which seek to provide a range of social and humanitarian services.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("NRM/A")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("National Resistance Movement/Army. Museveni’s guerrilla movement that fought against Milton Obote’s second regime during the “Bush War” of 1981–1986. Currently the ruling political party of Uganda. NRA refers to the military wing of the NRM (see also UNLA and UPDF).")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("RCD")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Rally for Congolese Democracy. A rebellion group formed in 1998 to fight against Kabila’s government; orchestrated by Rwanda and Uganda. Its formation triggered the Second Congo War.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("RPF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Rwandan Patriotic Front. Originally an insurgency group that invaded Rwanda from Uganda in 1990; currently the ruling political party of Rwanda under President Paul Kagame.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("UNAMIR")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("The United Nations Assistance Mission for Rwanda, established in 1993 as a peacekeeping force in Rwanda, commanded by General Roméo Dallaire.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("UNLA")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Uganda National Liberation Army. Obote’s government army that fought against Museveni’s NRA in the Bush War of 1981–1986.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("UPDA")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Uganda People’s Democratic Army, an insurgency formed in 1986 from remnants of Obote’s army, the UNLA.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("UPDF")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "td"
  }, [_vm._v("Uganda People’s Defence Force, formerly the NRA. The Ugandan military since 1995.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e8e2f862","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Abbreviations.vue
// module id = 81
// module chunks = 0